import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { NameAndImage } from '../../NameAndImage';
import { nameAndImage } from '../../sharedSchemas';
import { useEmergencyFundStep } from '../FlowConfig';

type FormValues = Yup.InferType<typeof nameAndImage>;

export const EmergencyFundNameAndImageStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const { commit, values } = useEmergencyFundStep('nameAndImage');

  const initialValues: FormValues = {
    name: values?.name || 'Emergency fund',
    imageType: values?.imageType,
  };

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);
    void navigate(`/add_purpose/emergency_fund/${flowId}/monthly_expenses`);
  };

  return <NameAndImage handleSubmit={handleSubmit} initialValues={initialValues} />;
};
